import RadioGroup from "@/components/forms/radio-group";
import Files from "@/components/forms/files";
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { FileCheck, Info } from 'lucide-react';
import type { DeclarationStepProps } from '@/pages/accident/declaration-sinistre/types';

const Constat = (props: DeclarationStepProps) => {
    const { errors, values, setValue } = props;

    return (
        <Card className="mt-6">
            <CardHeader className="pb-6 border-b">
                <CardTitle className="text-lg flex items-center gap-2">
                    <FileCheck className="w-5 h-5 text-primary" />
                    Constat amiable
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-6 space-y-8">
                <RadioGroup
                    label="Il y a-t-il un constat amiable ?"
                    name="constat_accident"
                    setValue={setValue}
                    options={[{ value: 'T', label: 'Oui' }, { value: 'F', label: 'Non' }]}
                    value={values.constat_accident}
                    error={errors.constat_accident}
                    required
                />

                {values.constat_accident === "T" && (
                    <>
                        <RadioGroup
                            label="Est-il signé par l'adversaire ?"
                            name="constat_sign_tiers"
                            setValue={setValue}
                            options={[{ value: 'T', label: 'Oui' }, { value: 'F', label: 'Non' }]}
                            value={values.constat_sign_tiers}
                            error={errors.constat_sign_tiers}
                            required
                        />
                        <RadioGroup
                            label="Est-il signé par vous ?"
                            name="constat_sign_assure"
                            setValue={setValue}
                            options={[{ value: 'T', label: 'Oui' }, { value: 'F', label: 'Non' }]}
                            value={values.constat_sign_assure}
                            error={errors.constat_sign_assure}
                            required
                        />
                        <div className="space-y-4">
                            <Files label="Constat amiable recto" name="files[C]" arrayName="files" value={values.files} setValue={setValue} code="C" />
                            <Files label="Constat amiable verso" name="files[CC]" arrayName="files" value={values.files} setValue={setValue} code="CC" />
                        </div>
                        <Alert>
                            <Info className="h-4 w-4" />
                            <AlertDescription>
                                La réception de votre constat amiable est nécessaire pour l'ouverture de votre dossier sinistre. Il permettra également de déterminer votre responsabilité.
                            </AlertDescription>
                        </Alert>
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default Constat;
